/* Replaced with ps-login-form */
import template from './login-form.html';

import LoginFormViewModel from './LoginFormViewModel.js';

export default {
	name: 'grape-ps-login-form',
	module_type: 'ko',
	template: template,
	viewModel: LoginFormViewModel
};

